<template>
  <div class="bf-modal orange">
    <div class="bf-modal__inner">
      <div class="bf-modal__title">
        <h6>
          {{ modalTitle }}
        </h6>
      </div>

      <div class="bf-modal__fields">
        <form-name-field
          ref="nameField"
          v-model="nameInput"
          class="form__input"
          round-border
          placeholder="как вас зовут?"
        />

        <form-phone-field
          ref="phoneField"
          class="form__input form__input_phone"
          round-border
          placeholder="ваш номер телефона"
          :errors-list="submitError"
          :error="validForm === false"
          @updatePhone="phoneInput = $event"
        />

        <form-email-field
          ref="emailField"
          v-model="emailInput"
          class="form__input"
          round-border
          :submit-error="submitError"
          placeholder="ваша почта"
          @clearSubmitError="clearSubmitError"
        />
      </div>

      <!-- eslint-disable -->
      <p class="bf-modal__law">
        нажимая на кнопку, вы соглашаетесь
        с&nbsp;<nuxt-link
          to="/privacy"
          target="_blank"
        >условиями обработки данных</nuxt-link>
          в&nbsp;соответствии
          с&nbsp;<nuxt-link
            to="/privacy"
            target="_blank"
        >политикой конфиденциальности</nuxt-link>
      </p>
      <!-- eslint-enable -->

      <button
        class="m-btn bf-modal__btn"
        @click="submit()"
      >
        подать заявку
      </button>
    </div>

    <button
      class="m-btn bf-modal__close"
      @click="$emit('closeModal')"
    >
      <img
        src="/v2/header/modal-close.svg"
        alt="close"
      >
    </button>

    <div
      class="bf-modal__overlay"
      @click="$emit('closeModal')"
    />
  </div>
</template>

<script>
import FormNameField from '@/components/v2/common/fileds/FormNameField.vue';
import FormEmailField from '@/components/v2/common/fileds/FormEmailField.vue';
import FormPhoneField from '@/components/v2/common/fileds/FormPhoneField.vue';

import sendLeadMixinConstructor from '@/mixins/sendLeadMixinConstructor';

const sendLeadMixin = sendLeadMixinConstructor({
  needName: true,
  needPhone: true,
  needEmail: true,
  needToSendTitle: true,
  needToSendComments: true,
});

export default {
  name: 'BlackFridayModal',
  components: {
    FormPhoneField,
    FormEmailField,
    FormNameField,
  },
  mixins: [sendLeadMixin],
  props: {
    modalTitle: {
      type: String,
      default: '',
    },
  },

  computed: {
    titleToSend() {
      return this.modalTitle;
    },
  },
};
</script>

<style lang="scss" scoped>
.bf-modal {
  position: fixed;
  z-index: 99;
  inset: 0;
  display: grid;
  place-content: center;

  * {
    font-family: "Onest", sans-serif;
  }

  &__inner {
    position: relative;
    z-index: 2;
    width: calc(var(--scale) * 720);
    max-height: 98vh;
    overflow: auto;
    padding: calc(var(--scale) * 32) calc(var(--scale) * 40) calc(var(--scale) * 40);
    background-color: #FFFFFF;
    border-radius: calc(var(--scale) * 60);

    @include media-down($size-tablet) {
      max-width: calc(var(--scale) * 366);
      padding: calc(var(--scale) * 20) calc(var(--scale) * 8) calc(var(--scale) * 8);
      border-radius: calc(var(--scale) * 32);
    }
  }

  &__title {
    position: relative;

    h6 {
      padding-right: calc(var(--scale) * 30);
      position: relative;
      z-index: 2;
      font-weight: 500;
      font-size: calc(var(--scale) * 48);
      line-height: 110%;
      letter-spacing: -0.02em;
      color: #02120F;

      @include media-down($size-tablet) {
        font-size: calc(var(--scale) * 28);
        line-height: 95%;
        padding-inline: calc(var(--scale) * 8);
      }
    }
  }

  &__fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: calc(var(--scale) * 8);
    margin-block: calc(var(--scale) * 20);

    @include media-down($size-tablet) {
      padding-inline: calc(var(--scale) * 8);
    }

    .form__input {
      ::v-deep input:not(.phone-field__input) {
        width: 100%;
        height: calc(var(--scale) * 80);
        background-color: #FFFFFF;
        border: 1px solid rgba(167, 171, 172, 0.5);

        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: $black-color;

        @include media-down($size-tablet) {
          height: calc(var(--scale) * 68);
          font-size: calc(var(--scale) * 18);
        }

        &::placeholder {
          color: #A7ABAC;
        }
      }

      ::v-deep .phone-field__input {
        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: $black-color;

        @include media-down($size-tablet) {
          font-size: calc(var(--scale) * 18);
        }

        &::placeholder {
          color: #A7ABAC;
        }
      }

      ::v-deep .phone-field__wrap {
        height: calc(var(--scale) * 80);
        background-color: #FFFFFF;
        border: 1px solid rgba(167, 171, 172, 0.5);

        @include media-down($size-tablet) {
          height: calc(var(--scale) * 68);
        }

        input {
          border-radius: inherit;

          &::placeholder {
            color: #A7ABAC;
          }
        }

        &--error {
          border-color: #ff0040;
        }
      }
    }
  }

  &__law {
    margin-bottom: calc(var(--scale) * 40);

    font-weight: 400;
    font-size: calc(var(--scale) * 20);
    line-height: 130%;
    color: #A7ABAC;

    @include media-down($size-tablet) {
      font-size: calc(var(--scale) * 14);
    }

    a {
      text-decoration: underline;
      color: #FF9C12;

      @media (hover: hover) {
        &:hover {
          text-decoration: none;
        }
      }
    }
  }

  &__btn {
    width: 100%;
    padding: calc(var(--scale) * 36) calc(var(--scale) * 10);
    border-radius: calc(var(--scale) * 24);
    transition: 200ms;

    font-weight: 500;
    font-size: calc(var(--scale) * 32);
    line-height: 110%;
    color: #FFFFFF;

    @include media-down($size-tablet) {
      padding: calc(var(--scale) * 30) 0;
      font-size: calc(var(--scale) * 18);
    }
  }

  &__close {
    position: absolute;
    z-index: 2;
    right: calc(var(--scale) * 40);
    top: calc(var(--scale) * 30);
    width: calc(var(--scale) * 44);

    @include media-down($size-tablet) {
      right: calc(var(--scale) * 20);
      top: calc(var(--scale) * 15);
    }
  }

  &__overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(#02120F, 0.3);
    backdrop-filter: blur(5px);
    cursor: pointer;
  }

  &.orange {
    .bf-modal__title {
      p {
        background-color: #FFF0D1;
        color: #FF5319;
      }

      ::v-deep(span) {
        color: #FF5319;
      }
    }

    .bf-modal__btn {
      background-color: #FF5319;

      @media (hover: hover) {
        &:hover {
          background-color: #FF9C12;
        }
      }
    }
  }
}
</style>
